module.exports = __webpack_public_path__ + "media/images/redesign-images/shared/best-sellers/best-sellers-03-76041b6dcc9735e5b7d69431c87e2393.jpg";